<template>
  <!-- Se tiver rota, renderiza como link do Vue Router -->
  <router-link
    v-if="to"
    :to="to"
    :class="['btn-gex', `btn-gex--${variant}`, { 'btn-gex--block': block }]"
  >
    <slot />
  </router-link>

  <!-- Se for um botão de ação normal -->
  <button
    v-else
    :type="type"
    :disabled="disabled || loading"
    :class="['btn-gex', `btn-gex--${variant}`, { 'btn-gex--block': block }]"
    @click="$emit('click', $event)"
  >
    <span
      v-if="loading"
      class="spinner-border spinner-border-sm me-2"
    ></span>
    <slot />
  </button>
</template>

<script setup>
defineProps({
  to: { type: [String, Object], default: null },
  variant: { type: String, default: "primary" },
  block: { type: Boolean, default: true },
  disabled: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  type: { type: String, default: "button" },
});
defineEmits(["click"]);
</script>

<style scoped>
.btn-gex {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem 1rem;
  border-radius: 0.4rem;
  margin-top: 1rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  box-sizing: border-box;
}

.btn-gex--block {
  width: 100%;
}

/* Variante Principal (Roxo GEX) */
.btn-gex--primary {
  background: var(--roxo-primario);
  color: var(--branco);
}
.btn-gex--primary:hover {
  background: var(--roxo-medio);
}
</style>
